module.exports = "/packs/images/svg/facilities/extreme~479266212b617dc5c7ce6c98204cc774.svg";